import { writable } from "svelte/store";

export const steps = writable(0);